// extracted by mini-css-extract-plugin
module.exports = {"layout":"_1bZBkPJPcBuKB3bQgvXxpF","center":"_1HonKrDj_2_AeIj-JtI4Lk","full":"_3Zj0UFCMzPcRf18Oeuqj5H","whiteButton":"_2UnftnK54uyNqgtml5VTaJ"};